export default __webpack_public_path__ + "static/media/icon_tranfers_dark.bb21569e.svg";